import line from "../images/Line1.svg";
import Project from "./Project";
import Slider from "./Slider";
import { useState } from "react";

const sampleProjects = [
  {
    id: 1,
    title: "TastyGit",
    description:
      "TastyGit is a free resource and reference website that is all about Git and GitHub. It aims to use as a guide for developers and also for a beginner and aspiring developers who are new to version control systems and how to utilize it in your projects.",
    technology: "HTML, CSS, Bootstrap",
    urlLink: "https://tasty-git.vercel.app/",
  },
  {
    id: 2,
    title: "PlantBase",
    description:
      "PlantBase is a plant shop app where users can find and buy ornamental indoor and outdoor plants. It could help to promote environmental awareness and influence people to take care and be responsible of our planet by knowing how to grow and take care of plants",
    technology:
      "HTML, CSS, JavaScript, Bootstrap, PayPal API, Plant Identification API, House Plants API (via RapidAPI)",
    urlLink: "https://group-3-nickel-capstone.vercel.app/",
  },
  {
    id: 3,
    title: "Charming Pets",
    description:
      "Charming Pets is a pet training class and adoption website. Humanity also needs to show compassion towards animals and this website aims to promote animal welfare and influence people to respect and take care of animals and pets as a member of a family.",
    technology: "React JS, PHP Laravel, EmailJS, Mailtrap, Bootstrap, MySQL",
    urlLink: "https://group-3-nickel-capstone.vercel.app/",
  },
];

const slides = [];
const Projects = () => {
  return (
    <div className="mt-48 px-4 md:px-12" id="projects">
      <div className="flex">
        <img src={line} alt="" />
        <p>&emsp; Sample Works</p>
      </div>
      <h2 className="text-4xl uppercase font-semibold mt-12 md:px-24">
        PROJECTS
      </h2>
      <Slider/>
    </div>
  );
};

export default Projects;
